<script>
	import { imageLightbox } from "src/store/store";
	import Lightbox from "../../../components/Lightbox/Lightbox.svelte";
	import { splitCamelCaseAndCapitalize } from "src/utils/misc";
	import { onMount } from "svelte";

	export let detailData;

	let {
		job: { preInspection },
	} = detailData;

	let modalOpen = false;
	let imgIndex = 0;

	function handleOpenImage(i, imgs) {
		imgIndex = Number(i);
		modalOpen = !modalOpen;
	}

	onMount(() => {
		imageLightbox.set([]);
		const allImageUrls = Object.values(preInspection)
			.filter((item) => item && item.media)
			.flatMap((item) => item.media)
			.map((media) => media.url);
		imageLightbox.set(allImageUrls);
	});
</script>

{#if modalOpen}
	<Lightbox on:click={() => (modalOpen = false)} />
{/if}
<div class="d-flex">
	{#each Object.keys(preInspection) as item, index}
		{#if preInspection[item]?.media.length > 0}
			<div>
				<img
					class="inspect-img"
					src={preInspection[item]?.media[0].url}
					alt="job-inspection"
					on:click={() => handleOpenImage(index, preInspection)}
					on:keydown={() => {}}
				/>
				<div class="d-flex justify-content-center">
					<span>{splitCamelCaseAndCapitalize(item)}</span>
				</div>
			</div>
		{/if}
	{/each}
</div>

<style>
	.inspect-img {
		width: 160px;
		height: 160px;
		border-radius: 8px;
		margin-right: 5px;
	}
</style>
